
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.843 17.322l4.17-6.576c1.424-2.133 1.027-5.25-.863-6.818a5.123 5.123 0 00-3.312-1.187c-1.23 0-2.376.41-3.312 1.187-1.89 1.568-2.287 4.685-.869 6.809a.054.054 0 01.005.008l4.181 6.577zm-.005-15.41c1.426 0 2.755.476 3.842 1.378 2.201 1.826 2.672 5.447 1.029 7.908l-4.515 7.12a.415.415 0 01-.7 0l-4.529-7.124c-1.641-2.46-1.17-6.08 1.031-7.904A5.945 5.945 0 019.838 1.91zm-1.95 5.757c0 1.075.875 1.95 1.95 1.95s1.95-.875 1.95-1.95-.875-1.95-1.95-1.95-1.95.875-1.95 1.95zm-.83 0a2.782 2.782 0 012.78-2.78 2.782 2.782 0 012.78 2.78 2.783 2.783 0 01-2.78 2.78 2.783 2.783 0 01-2.78-2.78z","fill":"#fff"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"pin-mask0","maskUnits":"userSpaceOnUse","x":"3","y":"1","width":"13","height":"18"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.843 17.322l4.17-6.576c1.424-2.133 1.027-5.25-.863-6.818a5.123 5.123 0 00-3.312-1.187c-1.23 0-2.376.41-3.312 1.187-1.89 1.568-2.287 4.685-.869 6.809a.054.054 0 01.005.008l4.181 6.577zm-.005-15.41c1.426 0 2.755.476 3.842 1.378 2.201 1.826 2.672 5.447 1.029 7.908l-4.515 7.12a.415.415 0 01-.7 0l-4.529-7.124c-1.641-2.46-1.17-6.08 1.031-7.904A5.945 5.945 0 019.838 1.91zm-1.95 5.757c0 1.075.875 1.95 1.95 1.95s1.95-.875 1.95-1.95-.875-1.95-1.95-1.95-1.95.875-1.95 1.95zm-.83 0a2.782 2.782 0 012.78-2.78 2.782 2.782 0 012.78 2.78 2.783 2.783 0 01-2.78 2.78 2.783 2.783 0 01-2.78-2.78z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#pin-mask0)"}},[_c('path',{attrs:{"fill":"#fff","d":"M.667.667h18.667v18.667H.667z"}})])])
          )
        }
      }
    